import axios from 'axios'

const refreshEndpoint = '/api/v1/Account/refresh-token';
const authenticationRenewalLeadTimeMilliseconds = 10 * 1000;
const defaultAccessTokenLifetimeMilliseconds = 2 * 60 * 1000;
let refreshRequest: Promise<void> | null = null;
let nextAuthenticationRenewalAt = 0;

const isRefreshRequest = (url?: string) =>
  !!url && url.toLowerCase().includes(refreshEndpoint.toLowerCase());

const renewAuthenticationSession = (force = false): Promise<void> => {
  const renewalIsDue = Date.now() >= nextAuthenticationRenewalAt;

  if (!force && !renewalIsDue) {
    return Promise.resolve();
  }

  if (!refreshRequest) {
    refreshRequest = axios.post(refreshEndpoint, null, {
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' }
    }).then((response) => {
      const accessTokenExpiresAt = response.headers['x-access-token-expires-at-utc'];
      const parsedExpiry = accessTokenExpiresAt
        ? Date.parse(accessTokenExpiresAt)
        : Number.NaN;

      nextAuthenticationRenewalAt = Number.isNaN(parsedExpiry)
        ? Date.now() + defaultAccessTokenLifetimeMilliseconds
          - authenticationRenewalLeadTimeMilliseconds
        : parsedExpiry - authenticationRenewalLeadTimeMilliseconds;
    }).finally(() => {
      refreshRequest = null;
    });
  }

  return refreshRequest;
};

const redirectToLogin = (error: any) => {
    const responseLoginUrl = error?.response?.headers?.['x-authentication-login-url'];
    const webAppUrl = window.localStorage.getItem('Referrer');
    const loginUrl = responseLoginUrl
      ?? (webAppUrl ? `${webAppUrl.replace(/\/$/, '')}/Account/LogOff` : null);

    if (loginUrl) {
      try {
        const url = new URL(loginUrl, window.location.origin);
        const isTrustedHost = url.hostname === 'localhost'
          || url.hostname === 'callthecar.com'
          || url.hostname.endsWith('.callthecar.com');

        if ((url.protocol === 'https:' || url.hostname === 'localhost') && isTrustedHost) {
          window.location.assign(url.toString());
        }
      } catch {
        // Ignore malformed redirect headers and preserve the original API error.
      }
    }

  return Promise.reject(error);
};

const https = axios.create({
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true,
});

export const https_ = axios.create({
  // timeout: 5000,
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  withCredentials: true,
});

const addAuthenticationInterceptor = (client: any) => {
  client.interceptors.request.use(
    async (config: any) => {
      if (isRefreshRequest(config?.url)) {
        return config;
      }

      try {
        await renewAuthenticationSession();
        return config;
      } catch (error) {
        return redirectToLogin(error);
      }
    },
    (error: any) => Promise.reject(error));

  client.interceptors.response.use(
    (response: any) => response,
    async (error: any) => {
      const originalRequest = error?.config;
      const isUnauthorized = error?.response?.status === 401;
      const requestIsRefresh = isRefreshRequest(originalRequest?.url);

      if (isUnauthorized && originalRequest && !originalRequest._authenticationRetry && !requestIsRefresh) {
        originalRequest._authenticationRetry = true;

        try {
          await renewAuthenticationSession(true);
          return client.request(originalRequest);
        } catch {
          return redirectToLogin(error);
        }
      }

      if (isUnauthorized) {
        return redirectToLogin(error);
      }

      return Promise.reject(error);
    });
};

addAuthenticationInterceptor(https);
addAuthenticationInterceptor(https_);

export default https






